// extracted by mini-css-extract-plugin
export default {"boton":"UsuarioEditarScreen_boton__8tY++"};